import {
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  UPDATE_PROFILE_DATA,
  UPDATE_PROFILE_DATA_SUCCESS,
  UPDATE_PROFILE_DATA_FAILURE,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE
} from "../types";

export const getProfile = (payload) => ({
  type: GET_PROFILE,
  payload
});
export const getProfileSuccess = (payload) => ({
  type: GET_PROFILE_SUCCESS,
  payload,
});
export const getProfileFailure = (payload) => ({
  type: GET_PROFILE_FAILURE,
  payload,
});

export const updateProfileData = (payload) => ({
  type: UPDATE_PROFILE_DATA,
  payload
});
export const updateProfileSuccess = (payload) => ({
  type: UPDATE_PROFILE_DATA_SUCCESS,
  payload,
});
export const updateProfileFailure = (payload) => ({
  type: UPDATE_PROFILE_DATA_FAILURE,
  payload,
});

export const changePassword = (payload) => ({
  type: CHANGE_PASSWORD,
  payload
});
export const changePasswordSuccess = (payload) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload,
});
export const changePasswordFailure = (payload) => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload,
});
